import React, { useState, useEffect } from "react";
import { FaTrash } from "react-icons/fa";
import { formatDate } from "../../utils/dateUtils.js";
import ConfirmModal from "../modals/ConfirmModal.jsx";
import { deleteSub, getAllSubs } from "../../services/subsService.js";
import { showErrorToast, showSuccessToast } from "../../services/toastService.js";
import Pagination from "../Pagination.jsx";

const SubscriberManagement = ({ state, setState }) => {
	const [searchTerm, setSearchTerm] = useState("");
	const [showConfirmModal, setShowConfirmModal] = useState(false);
	const [selectedSubId, setSelectedSubId] = useState(null);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	const [itemsPerPage, setItemsPerPage] = useState(20);

	// Caricamento dei dati
	useEffect(() => {
		getAllSubs(searchTerm, currentPage, itemsPerPage)
			.then((response) => {
				setState(response.data.subs);
				setTotalPages(response.data.pagination.totalPages);
			})
			.catch(() => showErrorToast("Errore durante il caricamento dei subscriber."));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchTerm, currentPage, itemsPerPage]);

	// Gestione della ricerca
	const handleSearch = (e) => {
		const value = e.target.value.toLowerCase();
		setSearchTerm(value || ""); // Imposta una stringa vuota se non c'è valore
		setCurrentPage(1); // Reset alla prima pagina
	};

	// Mostra il modale di conferma
	const handleDeleteClick = (id) => {
		setSelectedSubId(id);
		setShowConfirmModal(true);
	};

	// Conferma eliminazione
	const handleConfirmDelete = () => {
		deleteSub(selectedSubId)
			.then(() => {
				showSuccessToast("Eliminazione avvenuta con successo");
				getAllSubs(searchTerm, currentPage, itemsPerPage).then((response) => {
					setState(response.data.subs);
					setTotalPages(response.data.pagination.totalPages);
				});
			})
			.catch(() => showErrorToast("Errore durante l'eliminazione del subscriber."))
			.finally(() => {
				setSelectedSubId(null);
				setShowConfirmModal(false);
			});
	};

	// Annulla eliminazione
	const handleCancelDelete = () => {
		setShowConfirmModal(false);
		setSelectedSubId(null);
	};

	const handlePageChange = (page) => {
		setCurrentPage(page);
	};

	return (
		<div>
			<h2 className="text-2xl font-bold mb-4 text-center">Gestione Subscriber</h2>

			{/* Campo di ricerca */}
			<div className="mb-4">
				<input
					type="text"
					placeholder="Cerca per email..."
					className="border border-gray-300 p-2 rounded w-full"
					value={searchTerm}
					onChange={handleSearch}
				/>
			</div>

			{/* Tabella Subscriber */}
			<table className="w-full border-collapse border border-gray-300">
				<thead>
					<tr className="bg-gray-200">
						<th className="border border-gray-300 p-2">ID</th>
						<th className="border border-gray-300 p-2">Email</th>
						<th className="border border-gray-300 p-2">Data e Ora Iscrizione</th>
						<th className="border border-gray-300 p-2">Azione</th>
					</tr>
				</thead>
				<tbody className="text-center">
					{state.length > 0 ? (
						state.map((sub) => (
							<tr key={sub.id}>
								<td className="border border-gray-300 p-2">{sub.id}</td>
								<td className="border border-gray-300 p-2">{sub.email}</td>
								<td className="border border-gray-300 p-2">
									{formatDate(sub.timestamp)}
								</td>
								<td className="border border-gray-300 p-2">
									<button
										id="delete"
										aria-label="Elimina"
										onClick={() => handleDeleteClick(sub.id)}
										className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
									>
										<FaTrash />
									</button>
								</td>
							</tr>
						))
					) : (
						<tr>
							<td
								colSpan="4"
								className="border border-gray-300 p-4 text-center text-gray-500"
							>
								Nessun iscritto trovato.
							</td>
						</tr>
					)}
				</tbody>
			</table>

			{/* Paginazione */}
			<Pagination
				currentPage={currentPage}
				totalPages={totalPages}
				onPageChange={handlePageChange}
				itemsPerPage={itemsPerPage}
				setItemsPerPage={setItemsPerPage}
			/>

			{/* Modale di Conferma */}
			{showConfirmModal && (
				<ConfirmModal
					message="Sei sicuro di voler eliminare questo subscriber?"
					onConfirm={handleConfirmDelete}
					onCancel={handleCancelDelete}
				/>
			)}
		</div>
	);
};

export default SubscriberManagement;
